var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 7.99992C14.6673 11.1426 14.6673 12.714 13.691 13.6903C12.7147 14.6666 11.1433 14.6666 8.00065 14.6666C4.85795 14.6666 3.28661 14.6666 2.3103 13.6903C1.33398 12.714 1.33398 11.1426 1.33398 7.99992C1.33398 4.85722 1.33398 3.28587 2.3103 2.30956C3.28661 1.33325 4.85795 1.33325 8.00065 1.33325",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7693 2.2896L12.3408 3.65158C13.4226 4.58913 13.9635 5.05791 13.9635 5.66675C13.9635 6.27559 13.4226 6.74436 12.3408 7.68192L10.7693 9.0439C10.2936 9.45616 10.0558 9.6623 9.86089 9.57331C9.66602 9.48433 9.66602 9.16959 9.66602 8.54011V7.52389C7.66602 7.52389 5.49935 8.45246 4.66602 10.0001C4.66602 5.0477 7.62898 3.80961 9.66602 3.80961V2.79339C9.66602 2.16391 9.66602 1.84917 9.86089 1.76019C10.0558 1.6712 10.2936 1.87733 10.7693 2.2896Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.de4bc8810204c342684596e6b246b211.svg";
export { ForwardRef as ReactComponent };